//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Gráficos
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
//Componentes material
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';
import Avaliacao from '../../models/Avaliacao';
import { TIPO_ESCOLHA, TIPO_INTEIRO, TIPO_NUMERICO } from '../../models/QuestionarioQuestao';

/**
 * Converte os dados das avaliações e das respostas para o formato a ser repassado para o gráfico
 * @param {Array<AvaliacaoResposta>} respostas Dados das respostas a serem exibidas
 * @param {Array<Avaliacao>} avaliacoes Dados das avaliações a serem exibidas
 * @returns {Object} Dados convertidos no formato esperado
 */
function retornarDados(respostas, avaliacoes) {
    //Identifica o tipo da questão
    const tipo = respostas[0].tipo;

    //Mapeia cada resposta para o formato esperado
    return respostas.map((resposta, indice) => {
        const resultado = {
            //Data de finalização da avaliação
            data: avaliacoes[indice].dataAlteracao.toLocaleDateString(),
            valor: null
        };
        //Para os tipos inteiro e numérico, basta pegar o valor da resposta
        if (tipo === TIPO_INTEIRO || tipo === TIPO_NUMERICO)
            resultado.valor = resposta.resposta;
        //Para o tipo escolha é necessário verificar se tem outro valor
        else if (tipo === TIPO_ESCOLHA) {
            //Opção 'outro' preenchida
            if (resposta.opcaoOutros && resposta.outro !== null)
                resultado.valor = resposta.outro;
            //Captura o valor da opção selecionada
            else {
                const opcao = resposta.opcoes.find(opcao => opcao.id === resposta.resposta);
                if (opcao)
                    resultado.valor = opcao.valor;
            }
        }
        //Retorna o valor preenchido
        return resultado;
    });
}

/**
 * Renderiza as respostas do tipo inteiro
 * @param {Object} props Propriedades do componente
 * @param {Array<AvaliacaoResposta>} props.respostas Dados das respostas a serem exibidas
 * @param {Array<Avaliacao>} props.avaliacoes Dados das avaliações a serem exibidas
 * @param {Object} props.classes Classes CSS do componente
 */
function ResultadoQuestaoGrafico({ respostas, avaliacoes }) {
    if (respostas.length === 0) return 'Nenhuma resposta encontrada';

    //Obtém os dados formatados para o gráfico
    const dados = retornarDados(respostas, avaliacoes);

    return (
        <TableRow>
            <TableCell colSpan={respostas.length}  >
                <ResponsiveContainer height={200} >
                    <LineChart data={dados} >
                        <Line type="monotone" dataKey="valor" connectNulls />
                        <YAxis />
                        <XAxis padding={{ right: 20, left: 20 }} dataKey="data" />
                        <Tooltip />
                    </LineChart>
                </ResponsiveContainer>
            </TableCell>
        </TableRow>
    );
}

ResultadoQuestaoGrafico.propTypes = {
    /** Dados das respostas a serem exibidas */
    respostas: PropTypes.arrayOf(PropTypes.instanceOf(AvaliacaoResposta)).isRequired,
    /** Dados das avaliacoes a serem exibidas */
    avaliacoes: PropTypes.arrayOf(PropTypes.instanceOf(Avaliacao)).isRequired
};

export default ResultadoQuestaoGrafico;